let API_BASE = "";

// Vite
if (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE) {
  API_BASE = import.meta.env.VITE_API_BASE;
}
// CRA
else if (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE) {
  API_BASE = process.env.REACT_APP_API_BASE;
}
// Default: vacío = mismo origen (sirve en ngrok o proxy)
else {

  //API_BASE = "";
  //Uncomment below line and comment above line for localhost 
 // API_BASE = "http://localhost:8080";
API_BASE = "https://api.finsmart.mx";
}

export const apiUrl = (path = "") => {
  const base = (API_BASE || "").replace(/\/+$/, "");
  const suffix = String(path || "").replace(/^\/+/, "");
  return base ? `${base}/${suffix}` : `/${suffix}`;
};

export default API_BASE;
